__turbopack_context__.v({
  "content_text": "step-confirmation-module-scss-module__nLe5lG__content_text",
  "controls": "step-confirmation-module-scss-module__nLe5lG__controls",
  "description": "step-confirmation-module-scss-module__nLe5lG__description",
  "title": "step-confirmation-module-scss-module__nLe5lG__title",
});
